import {useApi} from '@/composables/useApi'

const api = useApi()

export function TimedsService() {
    this.getTimedByIdVsls = function (vslId, type_date='') {
        return new Promise((resolve, reject) => {
            try {
                let params = type_date !== null ? type_date : {}
                api.get(`/timeds/vsls/${vslId}/stats`, {
                    params: params
                })
                    .then(res => {
                        resolve(res)
                    })
            } catch (error) {
                reject(error)
            }
        })
    }

    this.createAnalyticTimed = function (timed) {
        return new Promise((resolve, reject) => {
            try {
                api.post('/timeds', timed)
                    .then(resp => {
                        resolve(resp.data[0])
                    })
            } catch (error) {
                reject(error)
            }
        })

    }
}
